"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementSchedule = void 0;
const Delay_1 = require("./settlementschedule/Delay");
const Interval_1 = require("./settlementschedule/Interval");
exports.SettlementSchedule = {
    delay: Delay_1.Delay,
    interval: Interval_1.Interval,
};
